import { NextPage } from 'next';
import { GetStaticProps } from 'next';
import New from '@/components/screens/new/New';
import { BOOKS_FOR_PAGE, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { IBooksPage } from '@/interfaces/booksPage.interface';

const NewPage: NextPage<IBooksPage> = ({ books }) => {
  return <New books={books} sortingName="по просмотрам" sortingUrl={'sorting/visited'} />;
};

export const getStaticProps: GetStaticProps = async () => {
  const res = await fetch(`${API_URL}satellite/books/news?last_books_per_days=30&page=1&page_size=${BOOKS_FOR_PAGE}&sort_field=views_count&sort_reversed=true`);
  const books = await res.json();

  return {
    props: { books },
    revalidate: REVALIDATE_TIME,
  };
};

export default NewPage;
